export default "__VITE_ASSET__BBhMZTUc__"